import Vue from 'vue';
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as VueWindow from '@hscmap/vue-window';
import VueHotkey from 'v-hotkey';
// moment fue reemplazado por dayjs (ver @/util/dayjs-config). El locale 'es'
// ya se configura ahi via dayjs.locale('es'). No imports de moment/dist/...
import moment from '@/util/dayjs-config';
import JsonExcel from 'vue-json-excel';
import { VueMaskDirective } from 'v-mask';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { applyTheme, readPersistedTheme } from '@/themes/apply';
import { applyMarkerPalette } from '@/components/map-v2/theming/apply-markers';
import './filters';
import confirmPlugin from './plugins/confirm';
import autoTooltip from './plugins/auto-tooltip';
import './plugins/base';
import './plugins/chartist';
import './main.css';
import './assets/css/pattern.css';
import './assets/css/backoffice-v2.css';
import 'simplebar/dist/simplebar.css';

Vue.directive('mask', VueMaskDirective);
Vue.component('downloadExcel', JsonExcel);

// moment.locale('es') ya esta hecho en @/util/dayjs-config.

Vue.use(VueLoading);
Vue.use(VueWindow);
Vue.use(VueHotkey);
Vue.use(confirmPlugin, { vuetify, store });
Vue.use(autoTooltip);

Vue.config.productionTip = false;

// Suppress noisy AudioContext warnings from camera iframe players.
// Camera streams require user gesture to unlock audio — the internal players
// retry continuously, spamming this warning. They're harmless (video still plays).
(function filterAudioContextWarnings() {
  var originalWarn = window.console.warn;
  window.console.warn = function () {
    var first = arguments[0];
    if (typeof first === 'string' && first.indexOf('AudioContext was not allowed to start') !== -1) {
      return;
    }
    originalWarn.apply(window.console, arguments);
  };
}());
applyTheme(readPersistedTheme());
// Expone la paleta de markers del tema activo como CSS vars
// `--kln-marker-<nombre>` para que ENTITY_COLORS y los toggles del
// toolbar lean los hex correctos del sistema declarativo.
applyMarkerPalette();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

// eslint-disable-next-line no-extend-native, func-names
String.prototype.toSlug = function () {
  const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç';
  const to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc';
  const mapping = {};

  for (let i = 0, j = from.length; i < j; i++) mapping[from.charAt(i)] = to.charAt(i);
  // eslint-disable-next-line func-names
  const normalize = function (str) {
    const ret = [];
    for (let i = 0, j = str.length; i < j; i++) {
      const c = str.charAt(i);
      // eslint-disable-next-line no-prototype-builtins
      if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
      else ret.push(c);
    }
    return ret
      .join('')
      .replace(/[^-A-Za-z0-9]+/g, '-')
      .toLowerCase();
  };
  return normalize(this);
};

// eslint-disable-next-line no-extend-native, func-names
Array.prototype.toObject = function (key) {
  const object = {};
  this.forEach((item) => {
    object[item[key]] = item;
  });
  return object;
};
